export default function SelectInput({ identifier, options, onChange, value, mandatory, disabled, defaultOption }) {
    const constOptions = (options ? options : [{ value: "", label: "No options provided..." }])

    return (
        <select
            className={`select-input default-input ${mandatory ? "mandatory-input" : ""}`}
            name={identifier}
            id={identifier}
            onChange={onChange}
            required={mandatory}
            value={value}
            disabled={disabled}
        >
            <option className="select-option" value="" disabled={mandatory}>
                {mandatory
                    ? (defaultOption ? defaultOption : "--- Select an option ---")
                    : ""
                }
            </option>

            {constOptions.map((option) => (
                option.grouped ?
                    <optgroup className="select-option-group" key={option.value} label={option.label}>
                        {option.options.map((subOption) => (
                            <option className="select-option" key={subOption.value} value={subOption.value}>
                                {subOption.label}
                            </option>
                        ))}
                    </optgroup>
                    :
                    < option className="select-option" key={option.value} value={option.value} >
                        {option.label}
                    </option>
            ))
            }
        </select >
    );
}